export const faqs = [
  {
    question: '征途国际主要提供哪些国际化服务？',
    answer: '征途国际提供一站式国际化服务，涵盖全球市场拓展、跨境业务合作、国际资源对接、国际化战略咨询、品牌国际化和数字全球化等六大核心服务板块。我们根据客户的实际需求，提供从策略规划到落地执行的全链条服务。',
  },
  {
    question: '如何开始与征途国际合作？',
    answer: '您可以通过我们的官方网站提交合作咨询表单，或直接拨打服务热线 +86-400-888-9999。我们的专业顾问将在24小时内与您取得联系，了解您的具体需求，并为您量身定制国际化解决方案。',
  },
  {
    question: '征途国际的服务覆盖哪些国家和地区？',
    answer: '征途国际的服务网络覆盖全球主要经济体，包括东南亚、中东、欧洲、北美、非洲和拉美等地区。我们在全球20多个国家和地区设有分支机构或合作伙伴，能够为客户提供本地化的专业服务。',
  },
  {
    question: '中小型企业是否适合使用征途国际的服务？',
    answer: '当然。征途国际的服务方案具有高度灵活性，我们为不同规模的企业提供差异化的服务套餐。无论您是初创企业、成长型企业还是大型集团，我们都能为您匹配最合适的国际化解决方案和资源。',
  },
  {
    question: '征途国际的收费模式是怎样的？',
    answer: '我们的收费模式根据服务类型和项目复杂度灵活定制，包括项目制收费、年度顾问服务和按效果付费等多种方式。在正式合作前，我们会提供详细的报价方案，确保价格透明、价值对等。',
  },
  {
    question: '征途国际如何保障服务质量？',
    answer: '我们建立了完善的服务质量管理体系：首先，所有顾问均具备10年以上国际化业务经验；其次，每个项目配备专属项目经理全程跟进；最后，我们提供阶段性成果评估和满意度反馈机制，确保服务质量持续优化。',
  },
];